/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

// This code is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 16oTSa7DQBPEWCKQEY9DXA

import { createUseGlobalVariants } from "@plasmicapp/react-web";

import { useScreenVariants as useScreenVariantsgwStHxMLoAb } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: GWSt_HxMLoAb/globalVariant
import { TmpValue, useTmp } from "./PlasmicGlobalVariant__Tmp"; // plasmic-import: Eg80qUgzx6dV/globalVariant

export const _useGlobalVariants = createUseGlobalVariants({
  screen: useScreenVariantsgwStHxMLoAb,
  tmp: useTmp
});
